import React from 'react';
import Search from '../cats/Search';
import Cats from '../cats/Cats';

const Home = () => {
  return (
    <>
      <Search />
      <Cats />
    </>
  );
};

export default Home;
